import Header from "@/components/Header";
import AboutSection from "@/components/AboutSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import SEOHead from "@/components/SEOHead";

const AboutPage = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="من نحن | حسن عبدالله للمقاولات والديكورات بالرياض"
        description="حسن عبدالله للمقاولات والديكورات — خبرة أكثر من 15 عامًا في التصميم الداخلي والترميم والمقاولات العامة بالرياض. فريق متخصص وجودة عالية."
        canonical="/about"
      />
      <Header />
      <div className="pt-20">
        <AboutSection />
        <TestimonialsSection />
      </div>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default AboutPage;
